
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_93Vp5jjZyQxRzDqk8DRVNd902UU0NqLoi4Nnh_Cxgyz0AMeta } from "/app/web/app/pages/[id].vue?macro=true";
import { default as index65Jx60L5prBdZYOeUCMlh4HLKXre0eeBekoSATScb10Meta } from "/app/web/app/pages/index.vue?macro=true";
import { default as login5sCw3_2zRe50ObjtfchjT4GmxfVwAsb93RHDp5gofc8Meta } from "/app/web/app/pages/login.vue?macro=true";
import { default as inboxR9_tL7tJ8rJtOgaryiGs0svTOZNu8ZA_N_SJnF2BoOYMeta } from "/app/web/app/pages/app/inbox.vue?macro=true";
import { default as indexwebaqfGMEgY2zf_uZKNas9Ks7d4IScqH14_OZUA3VIkMeta } from "/app/web/app/pages/app/index.vue?macro=true";
import { default as new_45tenantGUHP5HEaj_ODXaz4qYJ9LZTPcfD4d8eH1t5TiKNoO30Meta } from "/app/web/app/pages/new-tenant.vue?macro=true";
import { default as hotelEajglHJYAfaSyErWTvOxjuVoQEsbsv0WhfkxJZKEicoMeta } from "/app/web/app/pages/app/settings/hotel.vue?macro=true";
import { default as index7nVunD_ENLrljKNNkKxtAZzI6Az6zjvZhu6fCcSsvuIMeta } from "/app/web/app/pages/app/settings/index.vue?macro=true";
import { default as members7Qh1i_tN8QGd_fne1ZRxeD3SKGntJNes_ikTZ49JPNsMeta } from "/app/web/app/pages/app/settings/members.vue?macro=true";
import { default as security2RJgbMPlv5BImw6CdwZYpsaeZIZUWQcfO34uZ8jjZUMMeta } from "/app/web/app/pages/app/settings/security.vue?macro=true";
import { default as integrationkk8urzmLeJzHZv87DqpdsbRvBy5sgQgjeCPCEtZ_DHcMeta } from "/app/web/app/pages/app/settings/integration.vue?macro=true";
import { default as notificationsTIeQp3BXyF_FJf_nqWAchF44vohr89LbzOa1eTQiY08Meta } from "/app/web/app/pages/app/settings/notifications.vue?macro=true";
import { default as settingswFmPK1VE_HBU_DoBK8x3WY1K7DrJAbHTwI3PZGnFjw8Meta } from "/app/web/app/pages/app/settings.vue?macro=true";
import { default as _91id_93LjvXvtJTOCMSgdfi3hKyia3VFQ3Utgxe6KqSGJKaKH4Meta } from "/app/web/app/pages/app/rooms/[id].vue?macro=true";
import { default as indexJSwjclqAvIqwAC25h7GhiPaWKIfKnz5GIWlpQSugCr0Meta } from "/app/web/app/pages/app/rooms/index.vue?macro=true";
import { default as indexWvf4Izilv1g7CEQ2iBikHKalRNB8_5Ie_vj_RHoI1J8Meta } from "/app/web/app/pages/app/bookings/index.vue?macro=true";
import { default as _91tenantId_93x7LMaXSOF2DDfv6XlDglOLWvhtYcXblj5B0kNM6NzJsMeta } from "/app/web/app/pages/booking/[tenantId].vue?macro=true";
import { default as index6A3lWgi2e5uU4IvkK7RMxHoMDl9LadxrdRdEBwRljkUMeta } from "/app/web/app/pages/app/customers/index.vue?macro=true";
import { default as editAgW9ds6_hoTEwrmeeoixijtY_xO1mEWvMLaf9Y_2viUMeta } from "/app/web/app/pages/app/bookings/[id]/edit.vue?macro=true";
import { default as indexfjGr50qGIecFisDysZEXYHgIFiXn6jtiq_ngwvvTQFwMeta } from "/app/web/app/pages/app/bookings/[id]/index.vue?macro=true";
import { default as editvkVILy9ebkqaTZYUuX6ruBpOju7uzPRNwV1PRAiOK3wMeta } from "/app/web/app/pages/app/customers/[id]/edit.vue?macro=true";
import { default as indexOj7RfJ_rFWbfNU0X9NyoR5ZYJT4gMrE3je0I7XOhavMMeta } from "/app/web/app/pages/app/customers/[id]/index.vue?macro=true";
export default [
  {
    name: "id",
    path: "/:id()",
    meta: _91id_93Vp5jjZyQxRzDqk8DRVNd902UU0NqLoi4Nnh_Cxgyz0AMeta || {},
    component: () => import("/app/web/app/pages/[id].vue")
  },
  {
    name: "index",
    path: "/",
    meta: index65Jx60L5prBdZYOeUCMlh4HLKXre0eeBekoSATScb10Meta || {},
    component: () => import("/app/web/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login5sCw3_2zRe50ObjtfchjT4GmxfVwAsb93RHDp5gofc8Meta || {},
    component: () => import("/app/web/app/pages/login.vue")
  },
  {
    name: "app-inbox",
    path: "/app/inbox",
    component: () => import("/app/web/app/pages/app/inbox.vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/app/web/app/pages/app/index.vue")
  },
  {
    name: "new-tenant",
    path: "/new-tenant",
    meta: new_45tenantGUHP5HEaj_ODXaz4qYJ9LZTPcfD4d8eH1t5TiKNoO30Meta || {},
    component: () => import("/app/web/app/pages/new-tenant.vue")
  },
  {
    name: settingswFmPK1VE_HBU_DoBK8x3WY1K7DrJAbHTwI3PZGnFjw8Meta?.name,
    path: "/app/settings",
    component: () => import("/app/web/app/pages/app/settings.vue"),
    children: [
  {
    name: "app-settings-hotel",
    path: "hotel",
    component: () => import("/app/web/app/pages/app/settings/hotel.vue")
  },
  {
    name: "app-settings",
    path: "",
    component: () => import("/app/web/app/pages/app/settings/index.vue")
  },
  {
    name: "app-settings-members",
    path: "members",
    component: () => import("/app/web/app/pages/app/settings/members.vue")
  },
  {
    name: "app-settings-security",
    path: "security",
    component: () => import("/app/web/app/pages/app/settings/security.vue")
  },
  {
    name: "app-settings-integration",
    path: "integration",
    meta: integrationkk8urzmLeJzHZv87DqpdsbRvBy5sgQgjeCPCEtZ_DHcMeta || {},
    component: () => import("/app/web/app/pages/app/settings/integration.vue")
  },
  {
    name: "app-settings-notifications",
    path: "notifications",
    component: () => import("/app/web/app/pages/app/settings/notifications.vue")
  }
]
  },
  {
    name: "app-rooms-id",
    path: "/app/rooms/:id()",
    component: () => import("/app/web/app/pages/app/rooms/[id].vue")
  },
  {
    name: "app-rooms",
    path: "/app/rooms",
    component: () => import("/app/web/app/pages/app/rooms/index.vue")
  },
  {
    name: "app-bookings",
    path: "/app/bookings",
    component: () => import("/app/web/app/pages/app/bookings/index.vue")
  },
  {
    name: "booking-tenantId",
    path: "/booking/:tenantId()",
    meta: { ...(_91tenantId_93x7LMaXSOF2DDfv6XlDglOLWvhtYcXblj5B0kNM6NzJsMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/app/web/app/pages/booking/[tenantId].vue")
  },
  {
    name: "app-customers",
    path: "/app/customers",
    component: () => import("/app/web/app/pages/app/customers/index.vue")
  },
  {
    name: "app-bookings-id-edit",
    path: "/app/bookings/:id()/edit",
    component: () => import("/app/web/app/pages/app/bookings/[id]/edit.vue")
  },
  {
    name: "app-bookings-id",
    path: "/app/bookings/:id()",
    component: () => import("/app/web/app/pages/app/bookings/[id]/index.vue")
  },
  {
    name: "app-customers-id-edit",
    path: "/app/customers/:id()/edit",
    component: () => import("/app/web/app/pages/app/customers/[id]/edit.vue")
  },
  {
    name: "app-customers-id",
    path: "/app/customers/:id()",
    component: () => import("/app/web/app/pages/app/customers/[id]/index.vue")
  }
]